module.exports = __webpack_public_path__ + "img/OSN.a0cd75e7.png";